import React from 'react';
import chooLogo from './images/Logo1024.jpg';
import searchResults from './images/screenshots/SearchResults.webp';
import follow from './images/screenshots/Follow.webp';
import journeyDetails from './images/screenshots/JourneyDetails.webp';
import journeyMapDetails from './images/screenshots/JourneyMapDetails.webp';
import pickOnMap from './images/screenshots/PickOnMap.webp';
import stopDepartures from './images/screenshots/StopDepartures.webp';
import './App.css';

function TestFlightLink({ className = '' }: { className?: string }) {
  return (
    <a
      className={`button button-primary ${className}`}
      href="https://testflight.apple.com/join/0xkik93p"
      target="_blank"
      rel="noreferrer"
    >
      Try ChooChoo with TestFlight
      <span aria-hidden="true">↗</span>
    </a>
  );
}

function App() {
  return (
    <div className="app-shell">
      <header className="site-header page-container">
        <a className="brand" href="/" aria-label="ChooChoo home">
          <img src={chooLogo} alt="" className="brand-mark" />
          <span className="brand-name">ChooChoo</span>
          <span className="badge">Beta</span>
        </a>
        <span className="header-note">Journey planning for iPhone</span>
      </header>

      <main>
        <section className="hero page-container" aria-labelledby="hero-title">
          <div className="hero-copy">
            <div className="hero-actions">
              <TestFlightLink />
              <span className="availability">Available for iPhone via TestFlight</span>
            </div>
          </div>
          <div className="hero-art" aria-hidden="true">
            <div className="hero-glow" />
            <div className="hero-card hero-card-back"><img src={follow} alt="" /></div>
            <div className="hero-card hero-card-front"><img src={searchResults} alt="" /></div>
          </div>
        </section>

        <section className="gallery page-container" aria-label="ChooChoo features">
            <article className="feature-card">
              <div className="feature-copy">
                <p className="kicker">Plan ahead</p>
                <h3>Find your way quickly</h3>
                <p>Search for the best connection and keep the whole journey in view.</p>
              </div>
              <div className="screenshot-frame">
                <img src={searchResults} alt="ChooChoo search results screen" loading="lazy" />
              </div>
            </article>
            <article className="feature-card feature-card-offset">
              <div className="feature-copy">
                <p className="kicker">Stay on track</p>
                <h3>Follow your journey</h3>
                <p>A clear view of every leg, stop, and change along the way.</p>
              </div>
              <div className="screenshot-frame">
                <img src={follow} alt="ChooChoo journey follow screen" loading="lazy" />
              </div>
            </article>
            <article className="feature-card">
              <div className="feature-copy">
                <p className="kicker">Every detail</p>
                <h3>Know what comes next</h3>
                <p>See departure times and journey details without the noise.</p>
              </div>
              <div className="screenshot-frame">
                <img src={journeyDetails} alt="ChooChoo journey details screen" loading="lazy" />
              </div>
            </article>
            <article className="feature-card">
              <div className="feature-copy">
                <p className="kicker">Explore freely</p>
                <h3>Pick a place on the map</h3>
                <p>Start a journey from exactly where you are or where you want to be.</p>
              </div>
              <div className="screenshot-frame">
                <img src={pickOnMap} alt="ChooChoo pick on map screen" loading="lazy" />
              </div>
            </article>
            <article className="feature-card feature-card-offset">
              <div className="feature-copy">
                <p className="kicker">See the route</p>
                <h3>Understand the whole trip</h3>
                <p>A map view that makes connections and changes easy to follow.</p>
              </div>
              <div className="screenshot-frame">
                <img src={journeyMapDetails} alt="ChooChoo journey map details screen" loading="lazy" />
              </div>
            </article>
            <article className="feature-card">
              <div className="feature-copy">
                <p className="kicker">At your stop</p>
                <h3>Live departures at a glance</h3>
                <p>Check what is leaving next and make your connection with confidence.</p>
              </div>
              <div className="screenshot-frame">
                <img src={stopDepartures} alt="ChooChoo stop departures screen" loading="lazy" />
              </div>
            </article>
        </section>

      </main>

      <footer className="site-footer page-container">
        <span>© ChooChoo</span>
        <span>Simple and fast journey planning</span>
      </footer>
    </div>
  );
}

export default App;
